export const appInfo = {
    name: 'MESC',
    template: 'PHF',
    version: '2.0.1.31',
    revisionDate: '2018-05-29 19:56:21',
    company: 'GENERAL MOTORS'
}
